import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getsensor_dag, getsensor_maand, getsensor_uur } from "../Standplaatsen/Reducers/actions";
import { fetchgastenverbruikone, deleteReservering, activeerReservering, addwkhboeking, changeampere, fetchActivityLogs, updategasten } from "./Reducers/actions";
import { sendExistingCodeToDoorsy, checkToegangsCodeStatus, fetchToegangsCodesOverzicht } from "../Admin/Toegangscontrole/Reducers/actions";
import { fixmessage, message } from "../../Reducers/loading/actions";
import { getsensordevice_id, getsensorstatus, schakelkwhnmeter } from "../Sensors/Reducers/actions";
import { useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import BarGraph from "./Components/graphelectra";
import { Link } from "react-router-dom";
import Tabel from "./Components/tabelelectra";
import FilterSensor from "./Components/filterelect";
import Loading from "../../Components/loading/loading";

import BoekingsregelsTabel from "./Components/BoekingsRegels";
import Gastenkaart from "./Components/Gastenkaart";
import ActivityLogs from "./Components/ActivityLogs";
import SendAlertStatus from "./Components/SendAlertStatus";
import AddKWHForm from "../Standplaatsen/Kampeerplaatsen/Components/forms/addkwh";
import AddAmpereForm from "../Standplaatsen/Kampeerplaatsen/Components/forms/ampere";
const GastenVerbruikKampeer = (props) => {
  const [load, Setload] = useState(false);
  const [openmodal, Setopenmodal] = useState(false);
  const [kampeerplaatsid, Setkampeerplaatsid] = useState(null);
  const [datum_hour, Setdatum_hour] = useState({
    startdate: moment().subtract(1, "days").toDate(),
    enddate: new Date(),
  });
  const [gemiddelde, Setgemiddelde] = useState(0);
  const [stand, setStand] = useState(0);
  const [standdag, setStandDag] = useState(0);
  const [dataType, setDataType] = useState("dag"); // "dag" or "uur"

  const [max, Setmax] = useState(0);
  // Acties menu state
  const [addnewkwh, setAddnewkwh] = useState(false);
  const [ampere, setAmpere] = useState(false);
  const [showActiesMenu, setShowActiesMenu] = useState(true);
  // Pincode visibility state
  const [showMainPincode, setShowMainPincode] = useState(false);
  const [showLocationPincodes, setShowLocationPincodes] = useState({});

  // Password generator state
  const [generatedPassword, setGeneratedPassword] = useState("");
  const [generatingPassword, setGeneratingPassword] = useState(false);

  // Toegangscode state
  const [generatingToegangsCode, setGeneratingToegangsCode] = useState(false);
  const [toegangsCodeResult, setToegangsCodeResult] = useState(null);
  const [doorsyStatus, setDoorsyStatus] = useState(null);
  const [checkingDoorsyStatus, setCheckingDoorsyStatus] = useState(false);

  const params = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    getvals()
      .then((data) => getvals_dag(data))
      .then((data) => getvals_uur(data))
      .then(() => Setload(true));
  }, []);

  function getvals() {
    return new Promise((resolve, reject) => {
      props.fetchgastenverbruikone(params.id).then((data) => {
        if (data.results) {
          resolve(data.results);
        } else {
          props.message(3000, "warning", "Er is een fout opgtreden bij het laden van de sensoren");
          reject(new Error("Er is een fout opgetreden bij het laden van de sensoren"));
        }
      });
    });
  }

  function getvals_dag(data) {
    return new Promise((resolve, reject) => {
      const aankomst = moment(data.aankomst);
      const vertrek = moment(data.vertrek).isValid() ? moment(data.vertrek) : moment();
      const verblijfsduurUren = vertrek.diff(aankomst, "hours");

      // Als verblijf <= 48 uur, gebruik uur-data voor meer detail
      if (verblijfsduurUren <= 48) {
        console.log(`Verblijfsduur ${verblijfsduurUren} uur - gebruik uur-data voor meer detail`);
        setDataType("uur");
        props
          .getsensor_uur(data.standplaats._id, {
            startdate: aankomst.toDate(),
            enddate: vertrek.toDate(),
          })
          .then((hourData) => {
            if (!hourData.results) {
              props.message(3000, "warning", "Er is een fout opgtreden bij het laden van de sensoren");
              reject(new Error("Er is een fout opgetreden bij het laden van de sensoren"));
            } else {
              const hourValues = hourData.results.data.map((element) => element.value);
              const totalVerbruik = hourValues.reduce((a, b) => a + b, 0);
              const aantalDagen = verblijfsduurUren / 24;
              const dagGemiddelde = aantalDagen > 0 ? totalVerbruik / aantalDagen : 0;

              Setgemiddelde(dagGemiddelde / 10);
              Setmax(Math.max(...hourValues));
              setStandDag(hourValues.reduce((acc, curr) => acc + curr, 0).toFixed(2));
              resolve(hourData.results);
            }
          });
      } else {
        // Normale dag-data voor langere verblijven
        console.log(`Verblijfsduur ${verblijfsduurUren} uur - gebruik dag-data`);
        setDataType("dag");
        props
          .getsensor_dag(data.standplaats._id, {
            startdate: aankomst.toDate(),
            enddate: vertrek.toDate(),
          })
          .then((dayData) => {
            if (!dayData.results) {
              props.message(3000, "warning", "Er is een fout opgtreden bij het laden van de sensoren");
              reject(new Error("Er is een fout opgetreden bij het laden van de sensoren"));
            } else {
              const dayValues = dayData.results.data.map((element) => element.value);
              Setgemiddelde(dayValues.reduce((a, b) => a + b, 0) / dayValues.length);
              Setmax(Math.max(...dayValues));
              setStandDag(dayValues.reduce((acc, curr) => acc + curr, 0).toFixed(2));
              resolve(dayData.results);
            }
          });
      }
    });
  }

  function getvals_uur(data) {
    return new Promise((resolve, reject) => {
      props.getsensor_uur(data._id, datum_hour).then((data) => {
        if (!data.results) {
          props.message(3000, "warning", "Er is een fout opgtreden bij het laden van de sensoren");
          reject(new Error("Er is een fout opgetreden bij het laden van de sensoren"));
        } else {
          if (data.results.data && data.results.data[0]) setStand(data.results.data[0].value.toFixed(2));
          resolve();
        }
      });
    });
  }

  const { kampeerplaats, gastverbruik } = props;

  // Check Doorsy status when gastverbruik loads
  useEffect(() => {
    if (gastverbruik?.pincode) {
      checkDoorsyStatusForCode(gastverbruik.pincode);
    } else if (gastverbruik?.pincodes?.length > 0) {
      checkDoorsyStatusForCode(gastverbruik.pincodes[0]);
    }
  }, [gastverbruik?.pincode, gastverbruik?.pincodes]);

  const handleDeleteReservation = async () => {
    if (window.confirm("Weet je zeker dat je deze reservering wilt verwijderen?")) {
      try {
        // Navigate first to prevent render errors
        navigate("/gastenverbruik");
        const result = await props.deleteReservering(params.id);
        if (result && result.success) {
          props.message(3000, "success", "Reservering succesvol verwijderd");
        } else {
          props.message(3000, "error", "Er is een fout opgetreden bij het verwijderen");
        }
      } catch (error) {
        props.message(3000, "error", "Er is een fout opgetreden bij het verwijderen");
      }
    }
  };

  const handleActivateReservation = async () => {
    if (window.confirm("Weet je zeker dat je deze reservering wilt activeren? Dit zal de sensor koppelen aan de reservering en de meterstand bij aankomst instellen.")) {
      try {
        const result = await props.activeerReservering(params.id);
        if (result && result.success) {
          props.message(3000, "success", "Reservering succesvol geactiveerd");
          // Refresh the data to show updated status
          getvals()
            .then((data) => getvals_dag(data))
            .then((data) => getvals_uur(data));
        } else {
          props.message(3000, "error", result?.errors?.global || "Er is een fout opgetreden bij het activeren");
        }
      } catch (error) {
        props.message(3000, "error", "Er is een fout opgetreden bij het activeren");
      }
    }
  };

  const handleReactivateReservation = async () => {
    if (window.confirm("Weet je zeker dat je deze reservering wilt re-activeren? Dit zal de sensor opnieuw koppelen maar de meterstand bij aankomst behouden.")) {
      try {
        const result = await props.activeerReservering(params.id);
        if (result && result.success) {
          props.message(3000, "success", "Reservering succesvol re-geactiveerd");
          // Refresh the data to show updated status
          getvals()
            .then((data) => getvals_dag(data))
            .then((data) => getvals_uur(data));
        } else {
          props.message(3000, "error", result?.errors?.global || "Er is een fout opgetreden bij het re-activeren");
        }
      } catch (error) {
        props.message(3000, "error", "Er is een fout opgetreden bij het re-activeren");
      }
    }
  };

  // Handler voor boeking afronden (net zoals in modal)
  const handleBoekingAfronden = async () => {
    if (window.confirm("Weet je zeker dat je deze boeking wilt afronden?")) {
      try {
        // Hier zou je de afronden actie moeten implementeren
        // Dit hangt af van hoe het in de modal is geïmplementeerd
        props.message(3000, "info", "Boeking afronden functionaliteit moet nog geïmplementeerd worden");
      } catch (error) {
        props.message(3000, "error", "Er is een fout opgetreden bij het afronden");
      }
    }
  };

  // Handler voor extra kWh toevoegen
  const handleSubmitAddKwh = async (values) => {
    try {
      const result = await props.addwkhboeking(gastverbruik._id, values);
      if (result && result.success) {
        props.message(3000, "success", "kWh succesvol toegevoegd");
        setAddnewkwh(false);
        // Refresh data
        getvals()
          .then((data) => getvals_dag(data))
          .then((data) => getvals_uur(data));
      } else {
        props.message(3000, "error", "Er is een fout opgetreden bij het toevoegen van kWh");
      }
    } catch (error) {
      props.message(3000, "error", "Er is een fout opgetreden bij het toevoegen van kWh");
    }
  };

  // Handler voor ampere wijzigen
  const handleSubmitChangeAmpere = async (values) => {
    try {
      const result = await props.changeampere(gastverbruik._id, values);
      if (result && result.success) {
        props.message(3000, "success", "Ampere succesvol gewijzigd");
        setAmpere(false);
        // Refresh data
        getvals()
          .then((data) => getvals_dag(data))
          .then((data) => getvals_uur(data));
      } else {
        props.message(3000, "error", "Er is een fout opgetreden bij het wijzigen van ampere");
      }
    } catch (error) {
      props.message(3000, "error", "Er is een fout opgetreden bij het wijzigen van ampere");
    }
  };

  // Generate 6-digit password
  const generatePassword = () => {
    const password = Math.floor(Math.random() * 900000 + 100000).toString();
    setGeneratedPassword(password);
    return password;
  };

  // Save generated password to guest data
  const handleSavePassword = async () => {
    if (!generatedPassword) {
      props.message(3000, "warning", "Genereer eerst een wachtwoord");
      return;
    }

    if (!gastverbruik?.gast?._id) {
      props.message(3000, "error", "Geen gastgegevens gevonden");
      return;
    }

    setGeneratingPassword(true);
    try {
      const result = await props.updategasten(gastverbruik.gast._id, {
        password: generatedPassword,
      });

      if (result && result.type !== "GASTEN_VERBRUIK_ERROR") {
        props.message(3000, "success", "Wachtwoord succesvol opgeslagen in stamgegevens");
        // Refresh guest data
        getvals();
      } else {
        props.message(3000, "error", "Er is een fout opgetreden bij het opslaan van het wachtwoord");
      }
    } catch (error) {
      props.message(3000, "error", "Er is een fout opgetreden bij het opslaan van het wachtwoord");
    } finally {
      setGeneratingPassword(false);
    }
  };

  // Check Doorsy status for existing code
  const checkDoorsyStatusForCode = async (code) => {
    if (!code) return;

    setCheckingDoorsyStatus(true);
    try {
      // Use Redux action to fetch toegangscodes
      const overzichtResult = await props.fetchToegangsCodesOverzicht();

      if (overzichtResult && overzichtResult.success && overzichtResult.data) {
        const codeData = overzichtResult.data.find((item) => item.code === String(code));

        if (codeData && codeData.uuid) {
          const statusResult = await props.checkToegangsCodeStatus(codeData.uuid);
          if (statusResult) {
            setDoorsyStatus(statusResult);
          }
        }
      }
    } catch (error) {
      console.error("Error checking Doorsy status:", error);
    } finally {
      setCheckingDoorsyStatus(false);
    }
  };

  // Send existing toegangscode to Doorsy
  const handleSendCodeToDoorsy = async () => {
    if (!gastverbruik?._id) {
      props.message(3000, "error", "Geen gastenverbruik gevonden");
      return;
    }

    if (!gastverbruik.aankomst || !gastverbruik.vertrek) {
      props.message(3000, "error", "Aankomst en vertrek datums zijn vereist");
      return;
    }

    // Haal de bestaande code op (pincode of eerste pincode uit pincodes array)
    const existingCode = gastverbruik.pincode || (gastverbruik.pincodes && gastverbruik.pincodes.length > 0 ? gastverbruik.pincodes[0] : null);

    if (!existingCode) {
      props.message(3000, "error", "Geen bestaande toegangscode gevonden voor dit gastenverbruik");
      return;
    }

    // Valideer dat de code precies 5 cijfers is
    if (!/^\d{5}$/.test(String(existingCode))) {
      props.message(3000, "error", "Toegangscode moet precies 5 cijfers zijn om naar RecraPlan te versturen");
      return;
    }

    setGeneratingToegangsCode(true);
    try {
      const result = await props.sendExistingCodeToDoorsy({
        existingCode: existingCode,
        gastenverbruik_id: gastverbruik._id,
        startDate: gastverbruik.aankomst,
        endDate: gastverbruik.vertrek,
        beschrijving: `Toegangscode voor ${gastverbruik.gast?.voornaam || ""} ${gastverbruik.gast?.achternaam || ""} - ${gastverbruik.standplaats?.naam || "Onbekende standplaats"}`,
      });

      if (result && result.success) {
        setToegangsCodeResult(result);
        props.message(3000, "success", `Toegangscode ${result.code} succesvol verzonden naar RecraPlan!`);

        // Refresh data (activity log wordt automatisch op server toegevoegd)
        getvals();
      } else {
        props.message(3000, "error", result?.message || "Fout bij verzenden toegangscode");
      }
    } catch (error) {
      console.error("Error sending toegangscode:", error);
      props.message(3000, "error", "Fout bij verzenden toegangscode: " + (error.message || error));
    } finally {
      setGeneratingToegangsCode(false);
    }
  };

  if (load && gastverbruik && gastverbruik.standplaats) {
    return (
      <div className="row">
        <div className="col-12">
          <div className="box box-default">
            <div className="box-header with-border">
              <h3 className="box-title">
                Aankomst <strong> {moment(gastverbruik.aankomst).format("D MMMM: HH:00")}</strong> voor <strong>{gastverbruik.standplaats.naam} </strong>
                Vertrek: <strong> {moment(gastverbruik.vertrek).isValid() ? moment(gastverbruik.vertrek).format("D MMMM HH:mm") : moment().format("D MMMM HH:mm")}</strong>
                {gastverbruik.status === "checkout" ? <span className="badge badge-success ">Uitgechecked</span> : " "}
              </h3>
              <div className="box-tools pull-right">
                <Link to={`/gastenverbruik/gasten/edit/${gastverbruik.gast?._id}`} className="btn btn-info btn-sm" style={{ marginRight: "5px" }} title="Gastgegevens bewerken">
                  <i className="fa fa-edit" /> Gastgegevens
                </Link>
                <button className="btn btn-danger btn-sm" onClick={handleDeleteReservation} title="Reservering verwijderen">
                  <i className="fa fa-trash" /> Verwijderen
                </button>
              </div>
            </div>
            <div className="box-header with-border">
              <FilterSensor gastverbruik={gastverbruik} verbruik={standdag} gemiddelde={gemiddelde} max={max} stand={stand} />
            </div>
          </div>
        </div>
        {/* Main Content */}
        <div className="col-md-9">
          <div className="box box-default show-elecra">
            <Gastenkaart gastverbruik={gastverbruik} />

            <div className="box box-primary">
              <div className="box-body" />
              <div className="row p-2">
                <div className="col-12">
                  <Tabel sensor={dataType === "uur" ? kampeerplaats.uur : kampeerplaats.dag} gastverbruik={gastverbruik} />
                </div>
                <div className="col-12">
                  <BarGraph sensor={dataType === "uur" ? kampeerplaats.uur : kampeerplaats.dag} kleur="#B1BF41" type={dataType} />
                  <div className="mt-2">
                    <small className="text-muted">{dataType === "uur" ? "📊 Gedetailleerde uurweergave (verblijf ≤ 48 uur)" : "📊 Dagweergave (verblijf > 48 uur)"}</small>
                  </div>
                </div>
              </div>
            </div>

            <div className="box box-default">
              <div className="box-header with-border">
                <h3 className="box-title">Boekingsregels</h3>
              </div>
              <div className="box-body">
                <BoekingsregelsTabel boekingsregels={gastverbruik.boekingsregels} betalingen={gastverbruik.betaling} />
              </div>
            </div>

            <div className="box box-default">
              <div className="box-header with-border">
                <h3 className="box-title">Activity Log</h3>
                <div className="box-tools pull-right">
                  <Link to={`/gastenverbruik/activitylog/${gastverbruik._id}`} className="btn btn-primary btn-sm" title="Bekijk uitgebreide Activity Log met filters">
                    <i className="fa fa-external-link-alt" /> Uitgebreid overzicht
                  </Link>
                </div>
              </div>
              <div className="box-body">
                <ActivityLogs gastenverbruikId={gastverbruik._id} />
              </div>
            </div>

            <SendAlertStatus gastverbruik={gastverbruik} />
          </div>
        </div>

        {/* Sidebar */}
        <div className="col-md-3">
          <div className="box box-primary" style={{ position: "sticky", top: "20px", marginBottom: "20px" }}>
            <div className="box-header with-border">
              <h3 className="box-title">
                <i className="fas fa-door-open" style={{ marginRight: "8px" }}></i>RecraPlan Toegang
              </h3>
            </div>
            <div className="box-body" style={{ padding: "15px" }}>
              <p className="text-muted" style={{ fontSize: "12px", marginBottom: "15px" }}>
                Verstuur de bestaande toegangscode van dit gastenverbruik naar het RecraPlan systeem
              </p>

              {/* Show existing code */}
              {(gastverbruik.pincode || (gastverbruik.pincodes && gastverbruik.pincodes.length > 0)) && (
                <div style={{ marginBottom: "15px" }}>
                  <div
                    style={{
                      backgroundColor: "#f8f9fa",
                      border: "2px solid #6c757d",
                      borderRadius: "6px",
                      padding: "15px",
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "28px",
                        fontWeight: "bold",
                        color: "#495057",
                        letterSpacing: "3px",
                        fontFamily: "monospace",
                      }}
                    >
                      {gastverbruik.pincode || gastverbruik.pincodes[0]}
                    </span>
                    <div style={{ fontSize: "11px", color: "#495057", marginTop: "5px" }}>
                      Bestaande toegangscode
                      {gastverbruik.toegangscode?.doorsy?.actief_in_doorsy && (
                        <span style={{ marginLeft: "8px", color: "#28a745" }}>
                          <i className="fas fa-check-circle"></i> Actief in Doorsy
                        </span>
                      )}
                      {checkingDoorsyStatus && (
                        <span style={{ marginLeft: "8px", color: "#6c757d" }}>
                          <i className="fas fa-spinner fa-spin"></i> Status controleren...
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              )}

              <div>
                <button className="btn btn-primary btn-block" onClick={handleSendCodeToDoorsy} disabled={generatingToegangsCode} style={{ marginBottom: "8px", textAlign: "left" }}>
                  <i className={generatingToegangsCode ? "fas fa-spinner fa-spin" : "fas fa-paper-plane"} style={{ marginRight: "8px" }}></i>
                  {generatingToegangsCode ? "Bezig met verzenden..." : "Verstuur naar RecraPlan"}
                </button>
              </div>

              {gastverbruik?.gast && (
                <div style={{ marginTop: "10px", padding: "8px", backgroundColor: "#f8f9fa", borderRadius: "4px" }}>
                  <small className="text-muted">
                    <strong>Voor:</strong> {gastverbruik.gast.voornaam} {gastverbruik.gast.achternaam}
                    <br />
                    <strong>Standplaats:</strong> {gastverbruik.standplaats?.naam || "Onbekend"}
                    <br />
                    {gastverbruik.aankomst && gastverbruik.vertrek && (
                      <>
                        <strong>Periode:</strong> {moment(gastverbruik.aankomst).format("DD-MM-YYYY")} - {moment(gastverbruik.vertrek).format("DD-MM-YYYY")}
                      </>
                    )}
                  </small>
                </div>
              )}
            </div>
          </div>

          {/* Boeking Acties Sidebar */}
          {gastverbruik.standplaats?.device && (
            <div className="box box-default" style={{ marginTop: "20px" }}>
              <div className="box-header with-border">
                <h3 className="box-title">
                  <i className="fas fa-cog" style={{ marginRight: "8px" }}></i>Boeking Acties
                </h3>
              </div>
              <div className="box-body" style={{ padding: "15px" }}>
                {/* Boeking Acties */}
                <div style={{ marginBottom: "20px" }}>
                  <h6 className="text-muted" style={{ marginBottom: "10px", fontSize: "12px", textTransform: "uppercase" }}>
                    BOEKING BEHEER
                  </h6>
                  <div className="btn-group-vertical" style={{ width: "100%" }}>
                    <button type="button" className="btn btn-success btn-sm" onClick={handleBoekingAfronden} style={{ marginBottom: "5px", textAlign: "left" }}>
                      <i className="fas fa-check" style={{ marginRight: "8px" }}></i>
                      Boeking afronden
                    </button>

                    {Boolean(!gastverbruik.meterstanndaankomst || gastverbruik.meterstanndaankomst === 0) && (
                      <button className="btn btn-primary btn-sm" onClick={handleActivateReservation} title="Activeer reservering - koppel aan sensor en zet meterstand bij aankomst" style={{ marginBottom: "5px", textAlign: "left" }}>
                        <i className="fa fa-power-off" style={{ marginRight: "8px" }} />
                        Activeer Reservering
                      </button>
                    )}

                    {Boolean(gastverbruik.meterstanndaankomst && gastverbruik.meterstanndaankomst !== 0) && (
                      <button className="btn btn-warning btn-sm" onClick={handleReactivateReservation} title="Re-activeer reservering - koppel opnieuw aan sensor maar behoud meterstand bij aankomst" style={{ marginBottom: "5px", textAlign: "left" }}>
                        <i className="fa fa-refresh" style={{ marginRight: "8px" }} />
                        Re-activeer Reservering
                      </button>
                    )}
                  </div>
                </div>

                {/* Meter Instellingen */}
                <div>
                  <h6 className="text-muted" style={{ marginBottom: "10px", fontSize: "12px", textTransform: "uppercase" }}>
                    METER INSTELLINGEN
                  </h6>
                  <div className="btn-group-vertical" style={{ width: "100%" }}>
                    <button type="button" className="btn btn-warning btn-sm" onClick={() => setAddnewkwh(!addnewkwh)} style={{ marginBottom: "5px", textAlign: "left" }}>
                      <i className="fas fa-bolt" style={{ marginRight: "8px" }}></i>
                      Extra kWh
                    </button>

                    <button type="button" className="btn btn-warning btn-sm" onClick={() => setAmpere(!ampere)} style={{ textAlign: "left" }}>
                      <i className="fas fa-bolt" style={{ marginRight: "8px" }}></i>
                      Ampere instellen
                    </button>
                  </div>
                </div>

                {/* Forms */}
                {addnewkwh && (
                  <div style={{ marginTop: "15px", paddingTop: "15px", borderTop: "1px solid #eee" }}>
                    <AddKWHForm onSubmit={handleSubmitAddKwh} />
                  </div>
                )}
                {ampere && (
                  <div style={{ marginTop: "15px", paddingTop: "15px", borderTop: "1px solid #eee" }}>
                    <AddAmpereForm onSubmit={handleSubmitChangeAmpere} ampere={gastverbruik.ampere} />
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  } else {
    return <Loading loadings={load} />;
  }
};

function mapStateToProps(state) {
  return { sensor: state.sensoren, kampeerplaats: state.standplaatsen, gastverbruik: state.gastenverbruik.gastverbruik };
}

export default connect(mapStateToProps, {
  fetchgastenverbruikone,
  deleteReservering,
  activeerReservering,
  message,
  fixmessage,
  getsensor_dag,
  getsensor_maand,
  getsensor_uur,
  addwkhboeking,
  changeampere,
  getsensordevice_id,
  getsensorstatus,
  schakelkwhnmeter,
  fetchActivityLogs,
  updategasten,
  sendExistingCodeToDoorsy,
  checkToegangsCodeStatus,
  fetchToegangsCodesOverzicht,
})(GastenVerbruikKampeer);
